module.exports = __webpack_public_path__ + "img/efd3chicun.891118bc.png";